import * as React from 'react';
import { getCommunities } from '@/api/communities';
import { useQuery } from '@tanstack/react-query';

import { CommunitiesTable } from './components/communities-table';

export function AccountCommunitiesPage(): React.JSX.Element {
  const { data, isLoading, refetch } = useQuery({
    queryKey: ['communities', 'account'],
    queryFn: async () => await getCommunities(),
  });

  const communities = data?.communities ?? [];

  return (
    <CommunitiesTable
      communities={communities}
      loading={isLoading}
    />
  );
}
